module.exports = __webpack_public_path__ + "static/media/button-preview-ios.c063a371.svg";